module.exports = __webpack_public_path__ + "static/media/claracowen.662859d6.png";